import React, { Component } from 'react';
import DevisTableLayout from './DevisTableLayout';
import { Creatable } from 'react-select'
import { TableCell, Button, TableRow, IconButton, Box } from '@material-ui/core';
import { AddCircleRounded, CloseRounded, DeleteOutlined } from '@material-ui/icons';
import InputText, { InputSelect, InputSelectMagasin } from '../../../commonModules/interface/form-input-inline';
import { amber } from '@material-ui/core/colors';
import Currency from '../../../commonModules/Currency';

class Forms extends Component {
    state = { }
     createList(){
        // console.log("CREATE PRODUCT LIST");
        const { state } = this.props;
        const list = [{value:"", label:"Chosissez un Élément"}]
        const defaultList = [
            {id: "homme/jour", name: "Homme/Jour"},
            {id: "aller/retour", name: "Aller/Retour"},
            {id: "warranty12", name: "Toute intervention + Dépannage 12 mois"},
        ]
        defaultList.map( item => {   
            let selected = false
            state.newDevis[this.props.listName].map( prod => {   
                // if(prod.product_id  === item.id)   {  // already selected   
                //     selected = true 
                // } 
                selected = prod.product_id  === item.id
            })
            
            list.push (       
                {value:item.id, label: item.name , disabled:selected} 
            )
        })
        return list
    }

    createProductList(){        
        const list = []
        const  { PRODUCTS, inStockList, state } = this.props
        if(PRODUCTS){
            let selectedProds = state.newDevis.products.map( item => item.product_id)
            let products = Object.values(PRODUCTS)
            if (this.props.inStock) {
                products = products.filter(product => Object.keys(inStockList).includes(product.id) )
            }
            
            products.map( product => {   
                // Un produit désactivé n'est plus proposé au choix. Sa fiche
                // reste dans le store : une ligne déjà présente qui le cite
                // continue de s'afficher.
                if (product.is_disabled) return
                let selected = selectedProds.includes(product.id)
                if(
                    product.product_type !== "accesoires" && 
                    product.product_type !== "autres" && 
                    product.product_type !== "protection" && 
                    product.product_type !== "cables" 
                ){
                    list.push (       
                        {label:`${product.name} - ${product.marque}`, value:product.id, disabled:selected} 
                    )
                }
            })
        }
        return list
    }

    createAccList(){
        const  { PRODUCTS, inStockList, state } = this.props
        const list = []
        if(PRODUCTS){
            let selectedProds = state.newDevis.accessories.map( item => item.product_id)
            let products = Object.values(PRODUCTS)
            if (this.props.inStock) {
                products = products.filter(product => Object.keys(inStockList).includes(product.id) )
            }
            products.map( product => {   
                // Un produit désactivé n'est plus proposé au choix. Sa fiche
                // reste dans le store : une ligne déjà présente qui le cite
                // continue de s'afficher.
                if (product.is_disabled) return
                let selected = selectedProds.includes(product.id)
                if(
                    product.product_type === "accesoires" || 
                    product.product_type === "autres" || 
                    product.product_type === "protection" || 
                    product.product_type === "cables" )
                {
                    list.push (       
                        {value:product.id, label:`${product.name} - ${product.marque}`, disabled:selected} 
                    )
                }
            })
        }
        return list
    }
    createAddForm(infos){
        const { state, listName } = this.props;
        const {  numberName, prefix } = infos
        const tab = []
        let products = []
        
        switch (listName) {
            case "products" :
                products = this.createProductList()
                break
            case "accessories" :
                products = this.createAccList()
                break
            default :
                products = this.createList()
        }
        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < state[numberName];i++) {
            
            tab.push(
                <TableRow key={i} className={(state.errors[listName][i].product_id ? "Mui-error" : "")} style={{ verticalAlign: "top"}}>                        
                    <TableCell >
                        <Box style={{ display: "flex"}}>
                            <IconButton 
                                type="button" 
                                className="delete-line" 
                                onClick={() => this.props.handleDeleteProd(i, listName)}
                            >
                                <CloseRounded color="error" fontSize="small" />
                            </IconButton>
                            <Box style={{ width:"100%" }} >
                                <InputSelectMagasin
                                    options={products}
                                    value={state.newDevis[listName][i].display || {value:"", label:""}}
                                    placeholder="Selectionner un Produit"
                                    name={`product_${i+1}`}
                                    onChange={(option) => this.props.handleSelectProducts(option, i, listName) }
                                    isOptionDisabled={(option) => option.disabled === true}
                                    error={state.errors[listName][i].product_id}
                                />    
                            </Box>
                        </Box>
                 
                    </TableCell>

                    <TableCell className="text-center" style={{width: "150px"}}>
                        {/* <div className={"fg-line "+ (state.errors[listName][i].quantity ? "has-error" : "") }>
                            <input 
                                type="number" 
                                min={1} 
                                max={state.newDevis[listName][i].dispo} 
                                step={10} 
                                className="form-control input-lg" 
                                onChange={this.props.handleChange} 
                                value={state.newDevis[listName][i].quantity} 
                                name={`${prefix}-quantity-${i}`} 
                                placeholder="Quantité"/>
                            <small className="help-block text-center">{state.newDevis[listName][i].dispo !== "" ? "Disponible : "+ state.newDevis[listName][i].dispo :"" }</small>
                        </div> */}
                        <InputText
                            type="number" 
                            min={1} 
                            max={state.newDevis[listName][i].dispo} 
                            step={10} 
                            onChange={this.props.handleChange} 
                            value={state.newDevis[listName][i].quantity} 
                            name={`${prefix}-quantity-${i}`} 
                            placeholder="Quantité"
                            error={state.errors[listName][i].quantity}
                            helperText={state.newDevis[listName][i].dispo ? "Disponible : "+ state.newDevis[listName][i].dispo : "" }
                            required
                        />
                    </TableCell>
                    <TableCell className="">
                        {/* <div className={"fg-line "+ (state.errors[listName][i].price ? "has-error" : "") }>
                            <input 
                                // disabled
                                className="form-control input-lg" 
                                type="number" 
                                onChange={this.props.handleChange} 
                                value={state.newDevis[listName][i].price} 
                                name={`${prefix}-price-${i}`} 
                                placeholder="Prix"
                                />
                                <small className="help-block text-center">{state.newDevis[listName][i].priceR ? "Prix Unitaire Base: "+ state.newDevis[listName][i].priceR :"" }</small>
                            </div> */}
                        <InputText
                            type="number" 
                            onChange={this.props.handleChange} 
                            value={state.newDevis[listName][i].price} 
                            name={`${prefix}-price-${i}`} 
                            placeholder="Prix" 
                            error={state.errors[listName][i].price}
                            helperText={ state.newDevis[listName][i].priceR ? "Prix Unitaire Base: "+ state.newDevis[listName][i].priceR :"" }
                            required
                        />
                    </TableCell>
                    <TableCell className="">
                        <InputText
                            type="number" 
                            onChange={this.props.handleChange} 
                            value={state.newDevis[listName][i].priceTotal } 
                            name={`${prefix}-priceTotal-${i}`} 
                            placeholder="Prix Total"
                            error={state.errors[listName][i].priceTotal}
                            helperText={(state.newDevis[listName][i].priceR && state.newDevis[listName][i].quantity) ? "Prix Total Base : "+ 
                            (state.newDevis[listName][i].priceR * (state.newDevis[listName][i].quantity) ):"" }
                            required
                        />
                        {/* <div className={"fg-line "+ (state.errors[listName][i].priceTotal ? "has-error" : "") }>
                            <input 
                            disabled
                                type="number" 
                                className="form-control input-lg" 
                                onChange={this.props.handleChange} 
                                value={state.newDevis[listName][i].priceTotal } 
                                name={`${prefix}-priceTotal-${i}`} 
                                placeholder="Prix Total"/>
                            <small className="help-block text-center">
                            {(state.newDevis[listName][i].priceR && state.newDevis[listName][i].quantity) ? "Prix Total Base : "+ 
                            (state.newDevis[listName][i].priceR * (state.newDevis[listName][i].quantity) ):"" }</small>
                        </div> */}
                    </TableCell>
                    <TableCell className="">
                        {/* <div className={"fg-line "+ (state.errors[listName][i].TVA ? "has-error" : "") }>
                            <input 
                                type="number" 
                                className="form-control input-lg" 
                                onChange={this.props.handleChange} 
                                value={state.newDevis[listName][i].TVA } 
                                name={`${prefix}-TVA-${i}`} 
                                placeholder="Taux TVA"/>
                            <small className="help-block text-center"></small>
                        </div> */}
                        <InputText
                            type="number" 
                            oonChange={this.props.handleChange} 
                            value={state.newDevis[listName][i].TVA } 
                            name={`${prefix}-TVA-${i}`} 
                            placeholder="Taux TVA"
                            error={state.errors[listName][i].TVA}
                        />
                    </TableCell>
                        
                </TableRow>
                                        
            )
        }
        return tab;
    }
    
    render() {
        // console.log('====================================');
        // console.log("[STATE] EQUIPEMENT FORM ", this.state);
        // console.log('====================================');
        const { listName, state } = this.props;
        const infos = {
            products: { 
                name:"products", 
                numberName: "numberProd", 
                prefix:"prod_", 
                total:"prodTotal", 
                title: "Équipements",
                addName:"un Équipement"
            },
            accessories : { 
                name:"accessories", 
                numberName: "numberAcc", 
                prefix:"acc_", 
                total:"accTotal", 
                title: "Filerie, Supports, Protections",
                addName:"un Accessoire"
            },
            transport : { 
                name:"transport", 
                numberName: "numberTrans", 
                prefix:"trans_", 
                total:"transTotal", 
                title: "Transports, Assurances",
                addName:"un Élément"
            },
            mod: { 
                name:"mod", 
                numberName: "numberMOD", 
                prefix:"mod_", 
                total:"modTotal", 
                title: "Génie Civil et Main d'Oeuvre",
                addName:"un Élément"
            },
            warranty: { 
                name:"warranty", 
                numberName: "numberWarr", 
                prefix:"warr_", 
                total:"warrTotal", 
                title: "Garanties, Autres",
                addName:"un Élément"
            },
        }
        return (
            <DevisTableLayout title={infos[listName].title} color={amber[100]}>
                {this.createAddForm(infos[listName])}
                <TableRow className="" >
                    <TableCell colSpan={2} className="text-right">Total</TableCell>
                    <TableCell colSpan={3} className="text-left"><Currency value={state.newDevis[infos[listName].total]} /></TableCell>
                </TableRow>
                <TableRow className="plus-btn" onClick={()=>this.props.handleAddProd(this.props.listName)}>
                    <TableCell colSpan={5}>
                        <Button
                            startIcon={<AddCircleRounded />}
                            color="secondary"
                        >
                            Ajouter {infos[listName].addName}
                        </Button>
                    </TableCell>
                
                </TableRow>
            </DevisTableLayout>
        );
    }
}

export default Forms;

